import * as React from "react";
import { formatDate } from "src/util/formatDate";
import { IExpenseDetail } from 'src/services/interfaces/Expense/IExpenseDetail';
import { ExpenseStatusLabel } from 'src/services/Enum/ExpenseStatusEnum';
import { useState, useEffect, useContext } from 'react';
import { ServiceContext } from 'src/services/provider/Service.provider';
import { shortenTextMask } from 'src/util/Masks/StringMask';

interface IExpenseGeneralInfoProps {
  expense: IExpenseDetail;
}

export const ExpenseGeneralInfo: React.FC<IExpenseGeneralInfoProps> = ({ expense }) => {
  const { expenseRequestService } = useContext(ServiceContext);

  const [reason, setReason] = useState<string>(undefined);

  useEffect(() => {
    getReason();
  }, [expense.id]);

  function getReason() {
    expenseRequestService.getReason(expense.id)
      .then(resp => {
        setReason(resp.message);
      }).catch();
  }

  return (
    <div className="region-container client-info">
      <span className="subtitle">Informações Gerais</span>
      <div className="region-container">
        <div className="row">
          <span className="left description">Status:</span>
          <span className="right description">{ExpenseStatusLabel.get(expense.status)}</span>
        </div>
        {reason && (
          <div className="row">
            <span className="left description">Motivo:</span>
            <span className="right description">{shortenTextMask(reason, 50)}</span>
          </div>
        )}
        <div className="row">
          <span className="left description">Nome solicitante:</span>
          <span className="right description">{expense.createdUser.fullName}</span>
        </div>
        <div className="row">
          <span className="left description">Email solicitante:</span>
          <span className="right description">{expense.createdUser.login}</span>
        </div>
        <div className="row">
          <span className="left description">Data de Criação:</span>
          <span className="right description">{formatDate(expense.createdDate)}</span>
        </div>
        <div className="row">
          <span className="left description">Data da ultima atualização:</span>
          <span className="right description">{expense.lastUpdate ? formatDate(expense.createdDate) : formatDate(expense.lastUpdate)}</span>
        </div>
      </div>
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/components/common/ExpenseList/Details/ExpenseGeneralInfo/ExpenseGeneralInfo.tsx